import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import {
	createRootRouteWithContext,
	HeadContent,
	Outlet,
} from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

import { RootRouterContext } from '~/RootRouterContext.ts';

export const Route = createRootRouteWithContext<RootRouterContext>()({
	component: function RootComponent() {
		return (
			<>
				<HeadContent />
				<Outlet />
				<ReactQueryDevtools buttonPosition="bottom-right" />
				<TanStackRouterDevtools position="bottom-left" />
			</>
		);
	},
});
